import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";


const LoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    const formBody = new URLSearchParams();
    formBody.append("username", email);
    formBody.append("password", password);

    try {
      const response = await fetch(`${API_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formBody.toString(),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData.detail || "Credenciales inválidas");
        setLoading(false);
        return;
      }

      const data = await response.json();
      localStorage.setItem("token", data.access_token);
      // Limpiar cualquier reserva pendiente al iniciar sesión
      localStorage.removeItem("reserva_cita");

      const decoded = jwtDecode(data.access_token);
      // Redirigir a la ruta protegida
      navigate("/preregistro");
    } catch (err) {
      setError("Error de conexión con el servidor");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-primary_muted_bg">
      <div className="w-full md:w-1/2 flex flex-col justify-center px-8 py-12 bg-background">
        <div className="max-w-md w-full mx-auto">

          <h2 className="text-3xl font-bold mb-2 text-text_title">Inicia sesión</h2>
          <p className="text-sm text-text_title mb-6">
            Bienvenido de nuevo, ingresa tus datos para continuar
          </p>

          {error && (
            <div className="mb-4 text-red-600 font-semibold">{error}</div>
          )}

          <form className="space-y-4" onSubmit={handleSubmit}>
            <div>
              <label className="block text-sm font-medium mb-1 text-text_title">
                Correo electrónico
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tucorreo@ejemplo.com"
                className="w-full px-4 py-2 border border-primary_light rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1 text-text_title">
                Contraseña
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Tu contraseña"
                className="w-full px-4 py-2 border border-primary_light rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-primary text-white py-2 rounded-md hover:bg-primary_light transition disabled:opacity-50"
            >
              {loading ? "Ingresando..." : "Iniciar sesión"}
            </button>
          </form>
        </div>
      </div>

      <div className="hidden md:flex w-1/2 relative bg-primary text-white h-auto min-h-[500px] items-center justify-center">
        <img
          src="/images/index/TRAMITE.png"
          alt="Inspiración creativa"
          className="absolute inset-0 w-full h-full object-cover opacity-20"
        />
        <div className="relative z-10 p-6 rounded-lg text-center max-w-md">
          <div className="mb-8 bg-white rounded-md">
            <img src="/images/index/logo.png" alt="Logo" className="h-40 rounded-lg" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
